module.exports = {
	"description": "MenuGroups assemble [MenuItems](../menu-items) and can display a title.\nGrouping Menu options provides context clues to users about related actions.\nAn optional title can be added to reinforce the intent of the grouping.",
	"methods": [],
	"props": {
		"children": {
			"flowType": {
				"name": "React$Node"
			},
			"required": false,
			"description": "[MenuItems](../menu-item)"
		},
		"title": {
			"flowType": {
				"name": "React$Node"
			},
			"required": false,
			"description": "Title for the group"
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-docgen-loader!./src/Menu/MenuGroup.js
// module id = 1680
// module chunks = 0